import {
  CREATE_STRATEGY_PACK_ERROR,
  CREATE_STRATEGY_PACK_REQUEST,
  CREATE_STRATEGY_PACK_SUCCESS,
  CREATE_WATCHLISTS_ERROR,
  CREATE_WATCHLISTS_REQUEST,
  CREATE_WATCHLISTS_SUCCESS,
  DELETE_STRATEGY_PACK_ERROR,
  DELETE_STRATEGY_PACK_REQUEST,
  DELETE_STRATEGY_PACK_SUCCESS,
  DELETE_WATCHLISTS_ERROR,
  DELETE_WATCHLISTS_REQUEST,
  DELETE_WATCHLISTS_SUCCESS,
  EDIT_STRATEGY_PACK_ERROR,
  EDIT_STRATEGY_PACK_REQUEST,
  EDIT_STRATEGY_PACK_SUCCESS,
  GET_AVAILABLE_MARKETS_ERROR_NEW,
  GET_AVAILABLE_MARKETS_REQUEST_NEW,
  GET_AVAILABLE_MARKETS_SUCCESS_NEW,
  GET_INSIGHT_CHART_DATA_ERROR,
  GET_INSIGHT_CHART_DATA_REQUEST,
  GET_INSIGHT_CHART_DATA_SUCCESS,
  GET_INSIGHT_ARTIFACTS_ERROR,
  GET_INSIGHT_ARTIFACTS_REQUEST,
  GET_INSIGHT_ARTIFACTS_SUCCESS,
  GET_INSIGHT_INITIAL_INFO_ERROR_NEW,
  GET_INSIGHT_INITIAL_INFO_REQUEST_NEW,
  GET_INSIGHT_INITIAL_INFO_SUCCESS_NEW,
  GET_STRATEGY_SIGNALS_ERRORS,
  GET_STRATEGY_SIGNALS_REQUEST,
  GET_STRATEGY_SIGNALS_SUCCESS,
  GET_SYSTEM_STRATEGY_PACK_LIST_ERROR,
  GET_SYSTEM_STRATEGY_PACK_LIST_REQUEST,
  GET_SYSTEM_STRATEGY_PACK_LIST_SUCCESS,
  GET_USER_STRATEGY_PACK_LIST_ERROR,
  GET_USER_STRATEGY_PACK_LIST_REQUEST,
  GET_USER_STRATEGY_PACK_LIST_SUCCESS,
  GET_WATCHLISTS_ERROR,
  GET_WATCHLISTS_REQUEST,
  GET_WATCHLISTS_SUCCESS,
  GET_WATCHLIST_SUMMARY_ERROR,
  GET_WATCHLIST_SUMMARY_REQUEST,
  GET_WATCHLIST_SUMMARY_SUCCESS,
  MODIFY_WATCHLISTS_ERROR,
  MODIFY_WATCHLISTS_REQUEST,
  MODIFY_WATCHLISTS_SUCCESS,
  SET_CURRENT_STRATEGY,
  SET_INSIGHT_MARKET_TYPE,
} from "./consts";
import { getAllfeatures } from "../../utility/helper";

const initialState = {
  getInitialDataLoading: false,
  coefficients: {},
  overallStatistics: {},
  categories: [],
  categoriesTooltip: {},
  categoriesFeatureTree: {},
  allFeatures: [],
  getInitialDataError: "",
  initialDataFetched: false,
  insightMarketType: "crypto",
  availableMarkets: {},
  availableMarketsStatus: "",
  availableMarketsError: "",
  createStrategyStatus: "",
  createStrategyMessage: "",
  createStrategyError: "",
  createStrategyResult: {},
  userStrategies: [],
  isUserStrategiesFetched: false,
  userStrategiesStatus: "",
  userStrategiesError: "",
  systemStrategies: [],
  strategyGoodness: {},
  systemStrategiesStatus: "",
  systemStrategiesError: "",
  isSystemStrategiesFetched: false,
  editStrategyStatus: "",
  editStrategyMessage: "",
  editStrategyError: "",
  deleteStrategyStatus: "",
  deleteStrategyMessage: "",
  deleteStrategyError: "",
  signalData: [],
  chartId: "",
  signalStatus: "",
  signalError: "",
  insightSummary: {},
  insightVisualSummary: {},
  exportLinks: {},
  insightArtifactsStatus: "",
  insightArtifactsError: "",
  chartData: {},
  chartStatus: "",
  chartError: "",
  signalTableColumns: ["Signals"],
  currentStrategy: {},
  createWatchlistStatus: "",
  createWatchlistError: "",
  createWatchlistMessage: "",
  watchlistStatus: "",
  watchlists: [],
  watchlistError: "",
  watchlistsFetched: false,
  deleteWatchListStatus: "",
  deleteWatchListMessage: "",
  deleteWatchListError: "",
  modifyWatchListStatus: "",
  modifyWatchListMessage: "",
  modifyWatchListError: "",
  watchlistSummary: {},
  watchlistSummaryStatus: "",
  watchlistSummaryError: "",
};

export const newInsightReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_INSIGHT_INITIAL_INFO_REQUEST_NEW:
      return {
        ...state,
        getInitialDataLoading: true,
        getInitialDataError: "",
      };

    case GET_INSIGHT_INITIAL_INFO_SUCCESS_NEW:
      return {
        ...state,
        getInitialDataLoading: false,
        overallStatistics: payload?.OVERALL_STATISTICS,
        categories: payload?.CATEGORIES,
        categoriesFeatureTree: payload?.CATEGORIES_FEATURE_TREE,
        categoriesTooltip: payload?.categories_tooltip_mapping,
        allFeatures: getAllfeatures(payload?.CATEGORIES_FEATURE_TREE),
        initialDataFetched: true,
        coefficients: payload?.coefficients,
      };

    case GET_INSIGHT_INITIAL_INFO_ERROR_NEW:
      return {
        ...state,
        getInitialDataLoading: false,
        getInitialDataError: payload,
      };

    case SET_INSIGHT_MARKET_TYPE:
      if (state.insightMarketType === payload) return state;
      return {
        ...state,
        insightMarketType: payload,
        signalData: [],
        chartId: "",
        insightSummary: {},
        insightVisualSummary: {},
        exportLinks: {},
        insightArtifactsStatus: "",
        insightArtifactsError: "",
        initialDataFetched: false,
        isUserStrategiesFetched: false,
        userStrategies: [],
        systemStrategies: [],
        systemStrategiesStatus: "",
        isSystemStrategiesFetched: false,
        currentStrategy: {},
      };

    case GET_AVAILABLE_MARKETS_REQUEST_NEW:
      return {
        ...state,
        availableMarketsStatus: "loading",
        availableMarketsError: "",
      };
    case GET_AVAILABLE_MARKETS_SUCCESS_NEW:
      return {
        ...state,
        availableMarketsStatus: "idle",
        availableMarkets: payload,
      };
    case GET_AVAILABLE_MARKETS_ERROR_NEW:
      return {
        ...state,
        availableMarketsError: payload,
        availableMarketsStatus: "error",
      };

    case CREATE_STRATEGY_PACK_REQUEST:
      return {
        ...state,
        createStrategyStatus: "loading",
        createStrategyMessage: "",
        createStrategyError: "",
        createStrategyResult: {},
      };
    case CREATE_STRATEGY_PACK_SUCCESS:
      return {
        ...state,
        createStrategyStatus: "idle",
        createStrategyMessage: payload?.message,
        createStrategyResult: payload?.data,
      };
    case CREATE_STRATEGY_PACK_ERROR:
      return {
        ...state,
        createStrategyStatus: "error",
        createStrategyError: payload,
      };

    case GET_USER_STRATEGY_PACK_LIST_REQUEST:
      return {
        ...state,
        userStrategiesStatus: "loading",
        userStrategiesError: "",
      };
    case GET_USER_STRATEGY_PACK_LIST_SUCCESS:
      return {
        ...state,
        userStrategiesStatus: "idle",
        userStrategies: payload,
        isUserStrategiesFetched: true,
      };
    case GET_USER_STRATEGY_PACK_LIST_ERROR:
      return {
        ...state,
        userStrategiesStatus: "error",
        userStrategiesError: payload,
      };

    case GET_SYSTEM_STRATEGY_PACK_LIST_REQUEST:
      return {
        ...state,
        systemStrategiesStatus: "loading",
        systemStrategiesError: "",
      };
    case GET_SYSTEM_STRATEGY_PACK_LIST_SUCCESS:
      return {
        ...state,
        systemStrategiesStatus: "idle",
        systemStrategies: payload,
        strategyGoodness: action?.strategyGoodness || {},
        isSystemStrategiesFetched: true,
      };
    case GET_SYSTEM_STRATEGY_PACK_LIST_ERROR:
      return {
        ...state,
        systemStrategiesStatus: "error",
        systemStrategiesError: payload,
      };

    case EDIT_STRATEGY_PACK_REQUEST:
      return {
        ...state,
        editStrategyStatus: "loading",
        editStrategyError: "",
      };
    case EDIT_STRATEGY_PACK_SUCCESS:
      return {
        ...state,
        editStrategyStatus: "idle",
        editStrategyMessage: payload,
      };
    case EDIT_STRATEGY_PACK_ERROR:
      return {
        ...state,
        editStrategyStatus: "error",
        editStrategyError: payload,
      };

    case DELETE_STRATEGY_PACK_REQUEST:
      return {
        ...state,
        deleteStrategyStatus: "loading",
        editStrategyError: "",
      };
    case DELETE_STRATEGY_PACK_SUCCESS:
      return {
        ...state,
        deleteStrategyStatus: "idle",
        deleteStrategyMessage: payload,
      };
    case DELETE_STRATEGY_PACK_ERROR:
      return {
        ...state,
        deleteStrategyStatus: "error",
        deleteStrategyError: payload,
      };

    case GET_STRATEGY_SIGNALS_REQUEST:
      return {
        ...state,
        signalStatus: "loading",
        signalError: "",
        chartId: "",
        insightSummary: {},
        insightVisualSummary: {},
        exportLinks: {},
        insightArtifactsStatus: "",
        insightArtifactsError: "",
      };
    case GET_STRATEGY_SIGNALS_SUCCESS:
      if (payload?.status === "locked") {
        return {
          ...state,
          signalStatus: "idle",
          signalData: [],
          chartId: "",
          signalTableColumns: [],
        };
      }
      const signals = payload?.signals || [];
      const columnSet = [];
      signals.forEach((row) => {
        Object.keys(row || {}).forEach((key) => {
          if (!String(key).trim() || columnSet.includes(key)) return;
          columnSet.push(key);
        });
      });
      if (columnSet.includes("coin")) {
        columnSet.splice(columnSet.indexOf("coin"), 1);
        columnSet.unshift("coin");
      }
      return {
        ...state,
        signalStatus: "idle",
        signalData: signals,
        chartId: payload?.chart_id,
        signalTableColumns: columnSet,
      };
    case GET_STRATEGY_SIGNALS_ERRORS:
      return {
        ...state,
        signalStatus: "error",
        signalError: payload,
      };

    case GET_INSIGHT_ARTIFACTS_REQUEST:
      if (payload && payload !== state.chartId) return state;
      return {
        ...state,
        insightArtifactsStatus: "loading",
        insightArtifactsError: "",
      };
    case GET_INSIGHT_ARTIFACTS_SUCCESS:
      if (payload?.chartId !== state.chartId) return state;
      return {
        ...state,
        insightArtifactsStatus: "idle",
        insightArtifactsError: "",
        insightSummary: payload?.insightSummary || {},
        insightVisualSummary: payload?.visualSummary || {},
        exportLinks: payload?.exportLinks || {},
      };
    case GET_INSIGHT_ARTIFACTS_ERROR:
      return {
        ...state,
        insightArtifactsStatus: "error",
        insightArtifactsError: payload,
      };

    case GET_INSIGHT_CHART_DATA_REQUEST:
      return {
        ...state,
        chartStatus: "loading",
        chartError: "",
      };
    case GET_INSIGHT_CHART_DATA_SUCCESS:
      return {
        ...state,
        chartStatus: "idle",
        chartData: payload,
      };
    case GET_INSIGHT_CHART_DATA_ERROR:
      return {
        ...state,
        chartStatus: "error",
        chartError: payload,
      };

    case SET_CURRENT_STRATEGY:
      return {
        ...state,
        currentStrategy: payload,
      };

    case GET_WATCHLISTS_REQUEST:
      return {
        ...state,
        watchlistStatus: "loading",
        watchlistError: "",
      };
    case GET_WATCHLISTS_SUCCESS:
      return {
        ...state,
        watchlists: payload,
        watchlistStatus: "idle",
        watchlistsFetched: true,
      };
    case GET_WATCHLISTS_ERROR:
      return {
        ...state,
        watchlistStatus: "error",
        watchlistError: payload,
      };

    case CREATE_WATCHLISTS_REQUEST:
      return {
        ...state,
        createWatchlistStatus: "loading",
        createWatchlistError: "",
        createWatchlistMessage: "",
      };
    case CREATE_WATCHLISTS_SUCCESS:
      return {
        ...state,
        createWatchlistStatus: "idle",
        createWatchlistMessage: payload,
      };
    case CREATE_WATCHLISTS_ERROR:
      return {
        ...state,
        createWatchlistStatus: "error",
        createWatchlistError: payload,
      };

    case DELETE_WATCHLISTS_REQUEST:
      return {
        ...state,
        deleteWatchListStatus: "loading",
        deleteWatchListMessage: "",
        deleteWatchListError: "",
      };
    case DELETE_WATCHLISTS_SUCCESS:
      return {
        ...state,
        deleteWatchListStatus: "idle",
        deleteWatchListMessage: payload,
      };
    case DELETE_WATCHLISTS_ERROR:
      return {
        ...state,
        deleteWatchListStatus: "error",
        deleteWatchListError: payload,
      };

    case MODIFY_WATCHLISTS_REQUEST:
      return {
        ...state,
        modifyWatchListStatus: "loading",
        modifyWatchListError: "",
        modifyWatchListMessage: "",
      };
    case MODIFY_WATCHLISTS_SUCCESS:
      return {
        ...state,
        modifyWatchListStatus: "idle",
        modifyWatchListMessage: payload,
      };
    case MODIFY_WATCHLISTS_ERROR:
      return {
        ...state,
        modifyWatchListStatus: "error",
        modifyWatchListError: payload,
      };

    case GET_WATCHLIST_SUMMARY_REQUEST:
      return {
        ...state,
        watchlistSummaryStatus: payload?.replace ? "replacing" : "loading",
        watchlistSummaryError: "",
      };
    case GET_WATCHLIST_SUMMARY_SUCCESS:
      return {
        ...state,
        watchlistSummaryStatus: "idle",
        watchlistSummary: payload || {},
        watchlistSummaryError: "",
      };
    case GET_WATCHLIST_SUMMARY_ERROR:
      return {
        ...state,
        watchlistSummaryStatus: "error",
        watchlistSummaryError: payload,
      };

    default:
      return state;
  }
};
